module.exports = __webpack_public_path__ + "img/doc_fullmode.110d7386.png";